export default "__VITE_ASSET__CimH1xIY__"